// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IBubbleTextFieldSchema {
  /** Имя кнопки **/
  buttonName: string;
  /** Подсказка для поля ввода **/
  hint?: string;
  /** Вариант который надо отправить по socket-у **/
  socketPayload: string;
  /** Тип поля ввода **/
  textFieldType?: ETextFieldType;
}

export enum ETextFieldType {
  /** Текстовое поле ввода **/
  'Text' = 'text',
}
